import { useToastContext } from "components/alert/ToastContext";
import BaseDataTableEdit from "components/dataTableableEdit/BaseDataTableEdit";
import Produto from "model/administracao/cadastro/produto/Produto";
import LoteComponenteOP from "model/producao/LoteComponenteOP";
import EstoqueLote from "model/suprimentos/EstoqueLote";
import { Button } from "primereact/button";
import { Column, ColumnEditorOptions } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { useEffect, useState } from "react";
import ApontamentoOpService from "service/producao/ApontamentoService";

type Props = {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    style?: React.CSSProperties | undefined;
    produto: Produto;
    quantidade: number;
    lotes: LoteComponenteOP[];
    onConfirm: (lotes: LoteComponenteOP[]) => void;
}

const apontamentoOpService = new ApontamentoOpService();

export default function SelecaoLotesModal(props: Props) {

    const [lotes, setLotes] = useState<LoteComponenteOP[]>(JSON.parse(JSON.stringify(props.lotes)));
    const [lotesDisponiveis, setLotesDisponiveis] = useState<LoteComponenteOP[]>([]);

    const { msgAlerta } = useToastContext();

    useEffect(() => {
        apontamentoOpService.lotesDisponiveis(props.produto).then((data) => {
            setLotesDisponiveis(data);
        }).catch((error) => {
            console.error(error);
        })
    }, [])

    const validar = () => {
        for (let i = 0; lotes.length > i; i++) {
            if (lotes[i].qtUtilizada <= 0) {
                msgAlerta("Alerta", "Quantidade inválida para o lote " + lotes[i].estoqueLote.lote);
                return false;
            }
        }

        return true;

    }

    const sugerirLotes = () => {
        apontamentoOpService.sugerirLotes(props.produto, props.quantidade).then(data=>{
            if(data.length>0){
                setLotes(data);
            }else{
                msgAlerta("Quantidade indisponível", "Não foi possível encontrar lotes o suficiente que supram a quantidade necessária");
            }
        })
    }

    const editorLote = (options: ColumnEditorOptions) => {
        return <Dropdown
            value={options.rowData["estoqueLote"]}
            style={{ width: '100%' }}
            options={lotesDisponiveis}
            optionLabel="lote"
            itemTemplate={(item: EstoqueLote) => {
                return <div style={{ display: "flex", flexDirection: "column" }}>
                    <span><strong>Lote: </strong> {item.lote}</span>
                    <span><strong>Depósito:</strong> {item.deposito.nome}</span>
                    <span><strong>Quantidade:</strong> {item.quantidade.toLocaleString()}</span>
                </div>
            }}
            onChange={(e) => {
                options.rowData["estoqueLote"] = e.value;
                const lotesLocal = [...lotes];
                lotesLocal[options.rowIndex].estoqueLote = options.rowData["estoqueLote"];
                setLotes(lotesLocal);
            }}
        />
    }

    const editorQuantidade = (options: ColumnEditorOptions) => {
        return <InputNumber
            value={options.rowData[options.field]}
            style={{ width: '100%' }}
            minFractionDigits={isKgouLt(props.produto.unidadeMedida) ? 1 : 0}
            maxFractionDigits={isKgouLt(props.produto.unidadeMedida) ? 8 : 0}
            maxLength={12}
            locale="pt-BR"
            useGrouping={false}
            onChange={(e) => {
                options.rowData[options.field] = e.value;
                const lotesLocal = [...lotes];
                lotesLocal[options.rowIndex] = options.rowData;
                setLotes(lotesLocal);
            }}
        />
    }

    const isKgouLt = (unidadeMedida: string) => {
        return unidadeMedida == "KG" || unidadeMedida == "LT";
    }

    const confirmar = () => {
        if(validar()){
            props.onConfirm(lotes); props.setVisible(false)
        }
    }

    return (
        <Dialog header="Seleção de Lotes" visible={props.visible} style={{ width: '50vw', ...props.style }} onHide={() => { props.setVisible(false) }}
            footer={<>
                <Button label="Cancelar" onClick={() => props.setVisible(false)} />
                <Button label="Confirmar" onClick={() => { confirmar() }} />
            </>}>
            <div style={{ display: "flex", flexDirection: "column", rowGap: 24 }}>
                <div>
                    <div>
                        <span style={{ fontWeight: "bold" }}>Produto: </span>
                        <span>{props.produto.codigo} - {props.produto.nome}</span>
                    </div>
                    <div style={{ marginTop: 8 }}>
                        <span style={{ fontWeight: "bold" }}>Quantidade: </span>
                        <span>{props.quantidade.toLocaleString()} {props.produto.unidadeMedida}</span>
                    </div>
                </div>

                <BaseDataTableEdit
                    tituloLista="Lotes"
                    getNewModel={() => new LoteComponenteOP()}
                    lista={lotes ? lotes : []}
                    setLista={(e) => setLotes(e as LoteComponenteOP[])}
                    dataKey="key"
                    extraButtons={<Button label="Sugerir lotes" style={{marginRight: 8}} onClick={()=>sugerirLotes()} />}
                >
                    <Column field="estoqueLote.lote" header="Lote" editor={(options) => editorLote(options)} />
                    <Column field="estoqueLote.deposito.nome" header="Depósito" />
                    <Column field="qtUtilizada" header="Qtd. Utilizada" style={{ width: 150 }} editor={(options) => editorQuantidade(options)} />
                </BaseDataTableEdit>
            </div>



        </Dialog>
    )
}